(() => {
  const PRODUCT_PATH = /^\/products\/[^/?#]+\/?$/;

  function freshHref(href) {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return href;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return href;
    }

    if (url.origin !== window.location.origin || !PRODUCT_PATH.test(url.pathname)) return href;
    if (url.searchParams.get('view') !== 'default') return href;

    url.searchParams.delete('view');

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function refreshLink(link) {
    const current = link.getAttribute('href');
    const next = freshHref(current);
    if (next && next !== current) link.setAttribute('href', next);
  }

  function refreshAll(root = document) {
    root.querySelectorAll?.('a[href*="/products/"]').forEach(refreshLink);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', () => refreshAll());
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target?.closest?.('a[href*="/products/"]');
      if (link) refreshLink(link);
    },
    true,
  );

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) refreshAll(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const FLAG = '__zoalinPcHeaderActionRescueProductLink20260730V1';
  if (window[FLAG]) return;
  window[FLAG] = true;

  const PRODUCT_PATH = /^\/products\/[^/?#]+\/?$/;
  const MQ = '(min-width: 990px)';
  const ACTION = '44px';
  const ICON = '22px';
  const GAP = '10px';

  function set(node, prop, value) {
    node?.style?.setProperty(prop, value, 'important');
  }

  function isPc() {
    return window.matchMedia?.(MQ)?.matches;
  }

  function cleanCurrentProductView() {
    const url = new URL(window.location.href);
    if (!PRODUCT_PATH.test(url.pathname) || url.searchParams.get('view') !== 'default') return false;
    url.searchParams.delete('view');
    window.location.replace(`${url.pathname}${url.search}${url.hash}`);
    return true;
  }

  function cleanProductLink(link) {
    const href = link?.getAttribute?.('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin || !PRODUCT_PATH.test(url.pathname) || url.searchParams.get('view') !== 'default') return;
    url.searchParams.delete('view');
    link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  }

  function cleanLinks(root = document) {
    root.querySelectorAll?.('a[href*="/products/"][href*="view=default"]').forEach(cleanProductLink);
  }

  function accountHref() {
    const url = new URL(window.location.href);
    if (PRODUCT_PATH.test(url.pathname)) url.searchParams.delete('view');
    const returnTo = `${url.pathname}${url.search}${url.hash}`;
    return `/customer_authentication/login?return_to=${encodeURIComponent(returnTo)}&locale=en&ui_hint=full`;
  }

  function actionBox(node) {
    if (!node) return;
    set(node, 'position', 'relative');
    set(node, 'display', 'inline-flex');
    set(node, 'align-items', 'center');
    set(node, 'justify-content', 'center');
    set(node, 'flex', `0 0 ${ACTION}`);
    set(node, 'width', ACTION);
    set(node, 'min-width', ACTION);
    set(node, 'max-width', ACTION);
    set(node, 'height', ACTION);
    set(node, 'min-height', ACTION);
    set(node, 'max-height', ACTION);
    set(node, 'margin', '0');
    set(node, 'padding', '0');
    set(node, 'line-height', '0');
    set(node, 'overflow', 'visible');
    set(node, 'visibility', 'visible');
    set(node, 'opacity', '1');
    set(node, 'pointer-events', 'auto');
    set(node, 'transform', 'none');
    set(node, 'transition', 'none');
    set(node, 'animation', 'none');
  }

  function iconBox(node) {
    if (!node) return;
    set(node, 'display', 'inline-flex');
    set(node, 'align-items', 'center');
    set(node, 'justify-content', 'center');
    set(node, 'width', ICON);
    set(node, 'min-width', ICON);
    set(node, 'max-width', ICON);
    set(node, 'height', ICON);
    set(node, 'min-height', ICON);
    set(node, 'max-height', ICON);
    set(node, 'margin', '0');
    set(node, 'padding', '0');
    set(node, 'line-height', '0');
    set(node, 'pointer-events', 'none');
    set(node, 'transform', 'none');
  }

  function muteIconChildren(action) {
    action
      ?.querySelectorAll(
        ':scope > .svg-wrapper, :scope > .zoalin-account-icon-wrap, :scope > .zoalin-pc-heroicons-header-wrap, :scope > .zoalin-pc-menu-header-icon-wrap-final, cart-icon, .header-actions__cart-icon, svg, svg *',
      )
      .forEach(iconBox);
    action?.querySelectorAll('.account-button__text').forEach((node) => {
      set(node, 'display', 'none');
      set(node, 'visibility', 'hidden');
      set(node, 'opacity', '0');
      set(node, 'pointer-events', 'none');
    });
  }

  function headerRoot() {
    return document.querySelector('#header-component, header-component, header');
  }

  function rightColumn(header) {
    return header?.querySelector('.header__column--right');
  }

  function findActions(header, column) {
    return column?.querySelector(':scope > header-actions, :scope > .header-actions') || header?.querySelector('header-actions, .header-actions');
  }

  function findSearch(header, column) {
    return (
      column?.querySelector(':scope > search-button.search-action, :scope > search-button') ||
      header?.querySelector('search-button.search-action--hidden-on-drawer, search-button.search-action, search-button')
    );
  }

  function findWishlist(header) {
    return header?.querySelector('a.zoalin-wishlist-header, [data-zoalin-wishlist-header], a[href*="view=wishlist"], a[href*="wishlist"]');
  }

  function findCart(header) {
    return header?.querySelector(
      '[data-testid="cart-drawer-trigger"], button[aria-label="Cart"], button[aria-label*="Cart"], .action__cart, .header-actions__action:has(cart-icon), .header-actions__action:has(.header-actions__cart-icon), a[href="/cart"], a[href$="/cart"]',
    );
  }

  function findAccount(header) {
    return header?.querySelector(
      '.zoalin-account-hosted-link-20260707, a.account-button, a[href*="/customer_authentication/login"], a[href*="/account/login"], a[href*="/account"]',
    );
  }

  function createAccount() {
    const link = document.createElement('a');
    link.className = 'account-button header-actions__action color-custom-popover zoalin-account-hosted-link-20260707';
    link.href = accountHref();
    link.setAttribute('aria-label', 'Sign in to your ZOALIN account');
    link.setAttribute('data-zoalin-created-account', 'product-link-rescue-20260730');
    link.innerHTML = [
      '<span class="zoalin-account-icon-wrap" aria-hidden="true">',
      '<svg viewBox="0 0 24 24" focusable="false" role="presentation">',
      '<circle cx="12" cy="8" r="3.25" fill="none" stroke="currentColor" stroke-width="1.8"></circle>',
      '<path d="M5.75 19c.55-3.45 3.05-5.25 6.25-5.25s5.7 1.8 6.25 5.25" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>',
      '</svg>',
      '</span>',
    ].join('');
    return link;
  }

  function ensureAccount(header, actions) {
    let account = findAccount(header);
    if (account) {
      if (account.matches?.('a')) account.setAttribute('href', accountHref());
      return account;
    }
    if (!actions) return null;
    account = createAccount();
    const wishlist = findWishlist(header);
    try {
      actions.insertBefore(account, wishlist?.parentElement === actions ? wishlist : actions.firstChild);
    } catch {
      actions.insertBefore(account, actions.firstChild);
    }
    return account;
  }

  function stabilizeHeader() {
    cleanLinks();
    if (!isPc()) return;
    const header = headerRoot();
    const column = rightColumn(header);
    if (!header || !column) return;

    let actions = findActions(header, column);
    const search = findSearch(header, column);

    if (search && search.parentElement !== column) {
      try {
        column.insertBefore(search, actions?.parentElement === column ? actions : column.firstChild);
      } catch {}
    }
    if (actions && actions.parentElement !== column) {
      try {
        column.appendChild(actions);
      } catch {}
    }
    actions = findActions(header, column);

    set(column, 'position', 'fixed');
    set(column, 'top', '5px');
    set(column, 'right', 'max(48px, calc((100vw - 1440px) / 2 - 8px))');
    set(column, 'bottom', 'auto');
    set(column, 'left', 'auto');
    set(column, 'display', 'flex');
    set(column, 'align-items', 'center');
    set(column, 'justify-content', 'flex-end');
    set(column, 'gap', GAP);
    set(column, 'width', '206px');
    set(column, 'min-width', '206px');
    set(column, 'max-width', '206px');
    set(column, 'height', ACTION);
    set(column, 'margin', '0');
    set(column, 'padding', '0');
    set(column, 'overflow', 'visible');
    set(column, 'z-index', '2147482000');
    set(column, 'pointer-events', 'auto');
    set(column, 'visibility', 'visible');
    set(column, 'opacity', '1');
    set(column, 'transform', 'none');

    if (search) {
      actionBox(search);
      set(search, 'order', '1');
      const searchButton = search.querySelector('button, a') || search;
      actionBox(searchButton);
      muteIconChildren(searchButton);
    }

    if (actions) {
      set(actions, 'display', 'flex');
      set(actions, 'align-items', 'center');
      set(actions, 'justify-content', 'flex-end');
      set(actions, 'gap', GAP);
      set(actions, 'flex', '0 0 152px');
      set(actions, 'width', '152px');
      set(actions, 'min-width', '152px');
      set(actions, 'max-width', '152px');
      set(actions, 'height', ACTION);
      set(actions, 'margin', '0');
      set(actions, 'padding', '0');
      set(actions, 'order', '2');
      set(actions, 'overflow', 'visible');
      set(actions, 'pointer-events', 'auto');
      set(actions, 'transform', 'none');
    }

    const account = ensureAccount(header, actions);
    const wishlist = findWishlist(header);
    const cart = findCart(header);

    [
      [account, '1'],
      [wishlist, '2'],
      [cart, '3'],
    ].forEach(([node, order]) => {
      actionBox(node);
      set(node, 'order', order);
      set(node, 'grid-column', 'auto');
      muteIconChildren(node);
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      stabilizeHeader();
    });
  }

  if (cleanCurrentProductView()) return;
  stabilizeHeader();
  document.addEventListener('DOMContentLoaded', stabilizeHeader, { once: true });
  window.addEventListener('load', stabilizeHeader, { once: true });
  window.addEventListener('pageshow', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('click', (event) => cleanProductLink(event.target?.closest?.('a[href*="/products/"]')), true);
  [0, 50, 120, 240, 500, 900, 1600, 3000].forEach((delay) => setTimeout(stabilizeHeader, delay));
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) cleanLinks(node);
      }
    }
    schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'href', 'hidden', 'open'] });
})();

(() => {
  const MARKER = 'ZOALIN_PC_SHORT_VIEWPORT_DESKTOP_JS_LOADER_20260725';
  const id = 'zoalin-pc-short-viewport-desktop-restore-js-link-20260725';
  const fallbackHref = '/cdn/shop/t/1/assets/zoalin-pc-short-viewport-desktop-restore-20260725.css';

  function shouldLoad() {
    return window.matchMedia?.('(min-width: 990px)')?.matches;
  }

  function loadStylesheet() {
    if (!shouldLoad() || document.getElementById(id)) return;
    const existing = document.querySelector('link[href*="zoalin-pc-short-viewport-desktop-restore-20260725.css"]');
    const baseHref = existing?.href?.split('?')[0] || fallbackHref;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `${baseHref}?zoalin_pc_short_viewport=20260726_1128`;
    link.setAttribute('data-zoalin-marker', MARKER);
    document.head.appendChild(link);
  }

  loadStylesheet();
  document.addEventListener('DOMContentLoaded', loadStylesheet, { once: true });
})();

(() => {
  const MARKER = 'ZOALIN_PC_FOOTER_FLOW_GUARD_ASSET_20260726_1128';
  const mq = window.matchMedia?.('(min-width: 990px)');
  let pending = false;

  function important(element, property, value) {
    element?.style?.setProperty(property, value, 'important');
  }

  function realFooter(element) {
    return element?.tagName === 'FOOTER' && !!element.querySelector('.footer-content, .shopify-section-group-footer-group, .zoalin-pc-footer-copyright-final');
  }

  function restoreFooterFlow() {
    pending = false;
    if (mq && !mq.matches) return;

    const wrapper = document.querySelector('.page-wrapper');
    const main = document.getElementById('MainContent');
    if (!wrapper || !main) return;

    const footer = Array.from(document.body.querySelectorAll('footer')).find(realFooter) || wrapper.querySelector(':scope > footer');
    if (!footer) return;

    document.documentElement.setAttribute('data-zoalin-footer-flow-guard', MARKER);

    important(document.documentElement, 'height', 'auto');
    important(document.documentElement, 'min-height', '100%');
    important(document.documentElement, 'max-height', 'none');
    important(document.documentElement, 'overflow-x', 'hidden');
    important(document.documentElement, 'overflow-y', 'auto');
    important(document.body, 'height', 'auto');
    important(document.body, 'min-height', '100%');
    important(document.body, 'max-height', 'none');
    important(document.body, 'overflow-x', 'hidden');
    important(document.body, 'overflow-y', 'auto');
    important(document.body, 'display', 'block');

    if (footer.parentElement !== wrapper || wrapper.lastElementChild !== footer) {
      wrapper.appendChild(footer);
    }

    important(wrapper, 'display', 'block');
    important(wrapper, 'flex', 'none');
    important(wrapper, 'flex-direction', 'initial');
    important(wrapper, 'height', 'auto');
    important(wrapper, 'min-height', '100vh');
    important(wrapper, 'max-height', 'none');
    important(wrapper, 'overflow', 'visible');
    important(wrapper, 'scroll-behavior', 'auto');

    important(main, 'display', 'block');
    important(main, 'flex', 'none');
    important(main, 'height', 'auto');
    important(main, 'min-height', '0');
    important(main, 'max-height', 'none');
    important(main, 'overflow', 'visible');
    important(main, 'contain', 'none');
    important(main, 'clip-path', 'none');
    important(main, 'transform', 'none');
    important(main, 'clear', 'both');

    Array.from(main.children).forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      important(child, 'flex', 'none');
      important(child, 'width', '100%');
      important(child, 'clear', 'both');
    });

    important(footer, 'display', 'block');
    important(footer, 'flex', 'none');
    important(footer, 'position', 'relative');
    important(footer, 'top', 'auto');
    important(footer, 'right', 'auto');
    important(footer, 'bottom', 'auto');
    important(footer, 'left', 'auto');
    important(footer, 'z-index', '1');
    important(footer, 'width', '100%');
    important(footer, 'max-width', 'none');
    important(footer, 'margin-top', '0');
    important(footer, 'clear', 'both');
    important(footer, 'transform', 'none');
    important(footer, 'order', 'initial');
  }

  function scheduleRestore() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(restoreFooterFlow);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreFooterFlow, { once: true });
  else restoreFooterFlow();

  window.addEventListener('load', restoreFooterFlow);
  window.addEventListener('pageshow', restoreFooterFlow);
  window.addEventListener('resize', scheduleRestore);
  window.visualViewport?.addEventListener('resize', scheduleRestore);
  mq?.addEventListener?.('change', restoreFooterFlow);
  [0, 60, 180, 420, 900, 1600, 3000].forEach((delay) => setTimeout(restoreFooterFlow, delay));
  if (window.MutationObserver) new MutationObserver(scheduleRestore).observe(document.documentElement, { childList: true, subtree: true });
})();
